import { HOME_X } from './constants';
import type { Home } from './state';
export const createHomes = (): Home[] => HOME_X.map(x=>({x,occupied:false,fly:false,crocodile:false}));
export const homeIndex = (x: number): number => HOME_X.findIndex(cx => Math.abs(cx-x) <= 6);
